import { FocusTrap } from '@site-module/focus_trap';
import { Select } from '@site-module/select.js';

export default function initSidebarFilters() {

    const sidebar_filter = document.querySelector('.sidebar-agenda');

    if (!sidebar_filter) {
        return;
    }

    const filter_sidebar = sidebar_filter.querySelector('.filter-sidebar');
    const click_layer = sidebar_filter.querySelector('.sidebar-click-overlay');
    const custom_link_wrapper = sidebar_filter.querySelector('.filter-sidebar .custom-links');
    const custom_links = sidebar_filter.querySelectorAll('.filter-sidebar .custom-links a');
    let trap;

    // mobile overlay handling
    sidebar_filter.querySelector('.mobile-filters .other-filters').addEventListener('click', () => {
        click_layer.classList.add('open');
        filter_sidebar.classList.add('open');
        trap = new FocusTrap(filter_sidebar);
        trap.setTrap();
    });

    click_layer.addEventListener('click', () => {
        click_layer.classList.remove('open');
        filter_sidebar.classList.remove('open');
        if (trap) {
            trap.releaseTrap();
        }
    });

    filter_sidebar.querySelector('.close-button').onclick = () => {
        click_layer.classList.remove('open');
        filter_sidebar.classList.remove('open');
        trap.releaseTrap();
    };

    // implement custom links
    if (custom_links && custom_links.length) {
        custom_links.forEach((link) => {
            link.insertAdjacentHTML('beforeend', custom_link_wrapper.dataset.icon);
        });
    }

    // implement clicks on tags
    sidebar_filter.querySelectorAll('#sidebar-tags input[type="checkbox"]').forEach(checkbox => {
        const button = checkbox.nextElementSibling;
        if (!button) {
            return;
        }
        button.onclick = function() {
            if (checkbox.checked) {
                checkbox.checked = false;
                button.setAttribute('aria-pressed', 'false');
            } else {
                checkbox.checked = true;
                button.setAttribute('aria-pressed', 'true');
            }

            button.form.submit();
        };
    });

    // the tags filter is a disclosure: the toggle button shows/hides the tag list
    const tags_toggle = sidebar_filter.querySelector('[aria-controls="sidebar-tags"]');
    if (tags_toggle) {
        tags_toggle.addEventListener('click', () => {
            tags_toggle.setAttribute('aria-expanded', tags_toggle.getAttribute('aria-expanded') !== 'true');
        });
        document.getElementById(tags_toggle.getAttribute('aria-controls')).addEventListener('keyup', (event) => {
            if (event.key === 'Escape') {
                event.stopPropagation();
                event.preventDefault();
                tags_toggle.setAttribute('aria-expanded', 'false');
                tags_toggle.focus();
            }
        });
    }

    // generic implementation for other filters via "fancy selects"
    sidebar_filter.querySelectorAll('[data-fancy-select]').forEach(element => {
        new Select(element, element.closest('form'), element.dataset.style);
    });
}
